module.exports = "/img/_/_/_/assets/images/creeper/book/common//14.jpg?c9365bebfad34744aac69e17ddfc1c5d";